import FormSearhcAndSelectInput from 'common/FormSearchAndSelectInput';
import FormSelectInput from 'common/FormSelectInput';

import { categoriesOptions, categorySpecialties } from './constants';

export default function Specialty({ count, handleChange, extraSpecialty, extraSpecialtyCategory }) {
    const handleNameChange = (e, value) => {
        const fakeEvent = {
            target: { name: 'specialty_name', value },
        };
        handleChange(fakeEvent, count);
    };
    const handleCategoryChange = (e) => {
        handleChange(e, count);
    };

    return (
        <>
            <FormSelectInput
                name="specialty_category"
                value={extraSpecialtyCategory?.[count]}
                handleChange={handleCategoryChange}
                placeholder="Select Category"
                required={true}
                labelSize={0}
                inputSize={6}
                noLabel={true}
                options={categoriesOptions}
                optionValue={['category']}
                optionKey={'name'}
                style={{ marginBottom: '0px' }}
            />
            <FormSearhcAndSelectInput
                labelSize={0}
                inputSize={6}
                required={false}
                noLabel={true}
                name="specialty_name"
                options={categorySpecialties[extraSpecialtyCategory?.[count]]}
                value={extraSpecialty?.[count]}
                onChange={handleNameChange}
                disabled={false}
                placeholder="Select Specialty"
            />
        </>
    );
}
